/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_SearchInputs */

const vi_customer_search = /** @type {(inputs: Customer_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm khách hàng`)
};

/**

* @param {Customer_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_search = /** @type {((inputs?: Customer_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_search(inputs)
});